import { SelectListItem } from "../../utilities/selectlist-item";

export enum AddressDeliveryType {
    Van = 1,
    VanNoRack = 2,
    Conestoga = 4,
    ConestogaNoRack = 8,
    ConestogaSpreadAxle = 16,
    Gooseneck = 32,
    BoxTruck = 64,
    FedexUps = 128,
    LTL = 256
}

export const AddressDeliveryTypeMetadata = {
    '1': {
        display: '53\' Van',
        value: 1
    },
    '2': {
        display: '53\' Van - No Rack',
        value: 2
    },
    '4': {
        display: '48\' Conestoga',
        value: 4
    },
    '8': {
        display: '48\' Conestoga - No Rack',
        value: 8
    },
    '16': {
        display: 'Spread Axle Conestoga',
        value: 16
    },
    '32': {
        display: 'Gooseneck',
        value: 32
    },
    '64': {
        display: 'Box Truck',
        value: 64
    },
    '128': {
        display: 'FedEx/UPS',
        value: 128
    },
    '256': {
        display: 'LTL',
        value: 256
    }
}

const AddressDeliveryTypeSelectList = new Array<SelectListItem<string>>();
AddressDeliveryTypeSelectList.push(new SelectListItem({ id: '1', name: '53\' Van' }));
AddressDeliveryTypeSelectList.push(new SelectListItem({ id: '2', name: '53\' Van - No Rack' }));
AddressDeliveryTypeSelectList.push(new SelectListItem({ id: '4', name: '48\' Conestoga' }));
AddressDeliveryTypeSelectList.push(new SelectListItem({ id: '8', name: '48\' Conestoga - No Rack' }));
AddressDeliveryTypeSelectList.push(new SelectListItem({ id: '16', name: 'Spread Axle Conestoga' }));
AddressDeliveryTypeSelectList.push(new SelectListItem({ id: '32', name: 'Gooseneck' }));
AddressDeliveryTypeSelectList.push(new SelectListItem({ id: '64', name: 'Box Truck' }));
AddressDeliveryTypeSelectList.push(new SelectListItem({ id: '128', name: 'FedEx/UPS' }));
AddressDeliveryTypeSelectList.push(new SelectListItem({ id: '256', name: 'LTL' }));

export { AddressDeliveryTypeSelectList }